
  document.addEventListener('DOMContentLoaded', function () {
    var popupTriggers = document.querySelectorAll('.d6-nutrition-tag');
    var popupContainer = document.querySelector('.popup-container');
    var popupImage = document.querySelector('.popup-image');
    var closePopup = document.querySelector('.close-popup');
    
    popupTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var metafieldKey = this.getAttribute('data-metafield');
        var metafieldValue = this.getAttribute('data-metafield-value');
        
        // Fetch the image URL from the metafield
        var imageUrl = '{{ product.metafields.global[metafieldKey] }}';
        
        // Set the image source
        popupImage.src = imageUrl;
        
        // Display the popup
        popupContainer.style.display = 'block';
      });
    });
    
    closePopup.addEventListener('click', function () {
      // Close the popup
      popupContainer.style.display = 'none';
    });
  });
